import { Card, Group, Progress, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { AnalysisClient } from '@/api/analyses';
import { UnstyledButtonLink } from '@/components/links';
import { StatusBadge } from '@/components/StatusBadge';
import { useFormat } from '@/components/useFormat';
import { brand } from '@/theme/theme';

/** Client card: name, one status, progress while processing, delivery date. */
export function AnalysisCard({ analysis, projectId }: { analysis: AnalysisClient; projectId: string }) {
  const { t, i18n } = useTranslation('analyses');
  const { date } = useFormat();
  const lang = i18n.language as 'cs' | 'en';
  return (
    <UnstyledButtonLink to="/projects/$projectId/analyses/$analysisId" params={{ projectId, analysisId: analysis.public_id }} style={{ display: 'block' }}>
      <Card h="100%">
        <Stack gap="sm">
          <Group justify="space-between" align="flex-start" wrap="nowrap">
            <Text fz={16} fw={600} lh={1.3}>
              {analysis.name[lang] || analysis.name.cs}
            </Text>
            <StatusBadge status={analysis.client_status} scope="analysis" />
          </Group>
          {analysis.client_status === 'processing' && typeof analysis.progress === 'number' && (
            <Progress value={Math.round(analysis.progress * 100)} color="forest.6" bg="forest.0" size="sm" radius="sm" />
          )}
          <Text fz={13} c={brand.textMuted}>
            {analysis.delivered_at ? t('card.deliveredOn', { date: date(analysis.delivered_at) }) : t('card.plannedOn', { date: date(analysis.created_at) })}
          </Text>
        </Stack>
      </Card>
    </UnstyledButtonLink>
  );
}
